<script setup lang="ts">
import type { NavigationHookAfter } from 'vue-router';
import { onBeforeUnmount, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useRenewQuoteStore } from '@/entities/Stores/RenewQuote';
import { GA_EVENTS } from '@/shared/analytics';
import { usePushEvent } from '@/shared/composables';
import { MainLogo } from '@/shared/ui/MainLogo';

const pushEvent = usePushEvent();
const router = useRouter();
const renewQuoteStore = useRenewQuoteStore();

let unregisterRouterHook = () => {};

// TODO: почему здесь?
onMounted(async () => {
  const pushEventRouterHook: NavigationHookAfter = async (_, from) => {
    await pushEvent(GA_EVENTS.VIEW_PAGE, from, {
      policyNumber: renewQuoteStore.details?.policyNumber,
      quoteNumber: renewQuoteStore.quoteNumber,
    });
  };
  unregisterRouterHook = router.afterEach(pushEventRouterHook);
});

onBeforeUnmount(() => {
  unregisterRouterHook();
});
</script>

<template>
  <div class="flow-container">
    <div class="flow-container__content">
      <MainLogo class="flow-container__logo" />
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use 'FlowContainer';
</style>
